import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Input, Label, Spinner } from "reactstrap";

import { MediaDto } from "../../interfaces/media";
import avatar1 from "../../assets/images/users/user-dummy-img.jpg";
import { useUploadUserProfilePhotoMutation } from "../../store/api/userApi";
import { AccountState, setProfileImage } from "../../store/slices/accountSlice";
import { toast } from "react-toastify";

export const ProfilePicture = () => {
  //#region hooks
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  //#endregion

  //#region redux state
  const profile = useSelector(
    (state: { account: AccountState }) => state.account.userProfile,
  );

  const [
    uploadProfilePhotoApi,
    { isLoading: isLoadingUploadProfilePhoto, data: dataUploadProfilePhoto },
  ] = useUploadUserProfilePhotoMutation();

  //#endregion

  //#region handlers
  const onChangeImage = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;
    const { files } = target;
    if (files && files.length > 0) {
      const imageFile = files[0];
      if (
        !imageFile.name.match(
          /\.(jpg|JPG|jpeg|JPEG|jfif|pjpeg|pjp|png|PNG|webp|gif|GIF)$/,
        )
      ) {
        toast.error(t("selectValidImage"), {
          autoClose: 3000,
        });
        return false;
      }
      uploadProfilePhotoApi({ file: imageFile })
        .unwrap()
        .then((data: MediaDto) => {
          dispatch(setProfileImage(data.path));
        })
        .catch(() => {});
    }
  };

  //#endregion

  return (
    <Card>
      <CardBody className="p-4">
        <div className="text-center">
          <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
            <img
              src={
                dataUploadProfilePhoto?.path || profile?.profilePhoto || avatar1
              }
              className="rounded-circle avatar-xl img-thumbnail user-profile-image"
              alt="user-profile"
            />
            <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
              <Input
                onChange={onChangeImage}
                id="profile-img-file-input"
                type="file"
                className="profile-img-file-input"
                disabled={isLoadingUploadProfilePhoto}
              />
              <Label
                htmlFor="profile-img-file-input"
                className="profile-photo-edit avatar-xs"
              >
                <span className="avatar-title rounded-circle bg-light text-body">
                  {isLoadingUploadProfilePhoto && <Spinner />}
                  {!isLoadingUploadProfilePhoto && (
                    <i className="ri-camera-fill"></i>
                  )}
                </span>
              </Label>
            </div>
          </div>
          <h5 className="fs-16 mb-1">
            {i18n.language === "ar" ? profile?.name.ar : profile?.name.en}
          </h5>
          <p className="text-muted mb-1">
            {" "}
            {i18n.language === "ar"
              ? profile?.role?.name?.ar
              : profile?.role?.name.en}
          </p>
          <p className="text-muted mb-0" dir="ltr">
            {" "}
            +{profile?.phone.countryCode} {profile?.phone.phoneNumber}
          </p>
        </div>
      </CardBody>
    </Card>
  );
};
